import React from "react";
import { FormTab } from "@components/forms/common/FormTab";
import { ConsultantExpertiseInfo } from "../sections/ConsultantExpertiseInfo";

export function ExpertiseTab() {
  return (
    <FormTab horizontal>
      <ConsultantExpertiseInfo />
    </FormTab>
  );
}
